/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

const template = [
  {
    id: uuidV4(),
    value2: "",
    value3: "",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    value8a: "",
    value8b: "",
    value9a: "",
    value9b: "",
    value10: "",
    value11: "",
    value12: "",
    value13: "",
  },
];

function TaxPersonalTable02({ setFieldValue }) {
  const [data, setData] = useState(template);

  useEffect(() => {
    setFieldValue("valuesTable2", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8a: "",
      value8b: "",
      value9a: "",
      value9b: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column">
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={3} style={{ textAlign: "center", background: "#f4f4f4" }}>
                STT
              </Td>
              <Td rowSpan={1} colSpan={12} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số tiền còn phải nộp đề nghị bù trừ với số tiền nộp thừa
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số tiền còn phải nộp đề nghị bù trừ với số tiền nộp thừa
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số tiền còn phải nộp sau bù trừ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                MST của NNT khác (nếu có)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tên NNT khác (nếu có)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã định danh khoản phải nộp (ID)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Nội dung khoản nợ/phát sinh
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Chương
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tiểu mục
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tên CQT quản lý khoản thu
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Địa chỉ hành chính
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Hạn nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số tiền còn phải nộp
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "left", background: "#f4f4f4" }}>Cơ quan thuế cấp cục</Td>
              <Td style={{ textAlign: "left", background: "#f4f4f4" }}>Cơ quan thuế chi cục</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>Tỉnh</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>Huyện</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(1)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(2)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(3)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(4)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(5)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(6)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(7)</Td>
              <Td colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                (8)
              </Td>
              <Td colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                (9)
              </Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(10)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(11)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(12)</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>(13)=(11)-(12)</Td>
            </tr>
            {data &&
              data.length > 0 &&
              data.map((item, index) => (
                <tr key={item.id}>
                  <Td
                    className="toggle-button"
                    style={{ textAlign: "center", background: "transparent" }}
                  >
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete(item.id)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>{item.value2}</Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>{item.value3}</Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>{item.value4}</Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>{item.value5}</Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeSelect(item.id, "value6", e.target.value)}
                    >
                      <option value="value1">Value1</option>
                      <option value="value2">Value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeSelect(item.id, "value7", e.target.value)}
                    >
                      <option value="value1">Value1</option>
                      <option value="value2">Value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeSelect(item.id, "value8a", e.target.value)}
                    >
                      <option value="value1">Value1</option>
                      <option value="value2">Value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeSelect(item.id, "value8b", e.target.value)}
                    >
                      <option value="value1">Value1</option>
                      <option value="value2">Value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeSelect(item.id, "value9a", e.target.value)}
                    >
                      <option value="value1">Value1</option>
                      <option value="value2">Value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>
                    <select
                      style={selectStyle}
                      onChange={(e) => handleChangeSelect(item.id, "value9b", e.target.value)}
                    >
                      <option value="value1">Value1</option>
                      <option value="value2">Value2</option>
                    </select>
                  </Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>
                    <InputTable
                      id={item.id}
                      name="value11"
                      onChange={handleChange}
                      value={item.value11}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>
                    <InputTable
                      id={item.id}
                      name="value12"
                      onChange={handleChange}
                      value={item.value12}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", background: "#ddeff3" }}>
                    <InputTable
                      id={item.id}
                      name="value13"
                      onChange={handleChange}
                      value={item.value13}
                    />
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

export default memo(TaxPersonalTable02);

function InputTable(props) {
  const { onChange, type = "text", name, id, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name, type, id });
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.2rem 0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
